// extracted by mini-css-extract-plugin
export var button = "_dd-0";
export var icon = "_dd-1";